export const STOCK_ROUTE_MATERIAL_GROUP_LIST = "stock.materialGroup.list";
export const STOCK_ROUTE_CLIENT_MATERIALS = "stock.clientMaterials.list";
